/* ------------------------- External Dependencies -------------------------- */
import React from 'react';
import { Block } from 'atomic'
/* ---------------------------- Module Package ------------------------------ */
export default props => <Block {...props} onClick={props.dialogOpen}/>



// WEBPACK FOOTER //
// ./src/interface/containers/dialog/DialogOpen/render/index.js